export const EVENT_NAMESPACE = 'Usage Based Billing Components';
export const UPGRADE_EVENT_NAMESPACE = 'Upgrades';
export const EVENT_NAMES = {
  COMPONENT_INTERACTED: 'Component Interacted',
  COMPONENT_VIEWED: 'Component Viewed',
  PAGE_VIEWED: 'Page Viewed',
  TRIAL: 'Trial'
};
export const EVENT_ACTIONS = {
  CLICK: 'Click',
  TOOLTIP_OPEN: 'Tooltip Open',
  DATE_RANGE_CHANGE: 'Date Range Change',
  TIME_FRAME_CHANGE: 'Time Frame Change',
  TOGGLE_CHANGE: 'Toggle Change',
  ACTIVATION_SUCCEEDED: 'activation succeeded'
};